import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Button } from 'lp-components'
import { API_ERROR_MAP } from 'types'
import { logEvent } from 'uxcam-service'
import { resolvePage } from 'uxcam-pages'

// Shown when pricing can't load; asks the member to refresh before continuing.
function ProductPricesUnavailable() {
  const { pathname } = useLocation()

  // Reported with the page it replaced, so the flows this dead-ends most often
  // are countable rather than visible one replay at a time.
  useEffect(() => {
    logEvent('pricing_unavailable_shown', { page: resolvePage(pathname).name })
  }, [pathname])

  return (
    <section className="form-block-container">
      <div className="empty-state">
        <header>
          <h2>Something Went Wrong</h2>
        </header>
        <div className="card-inner">
          <p>{API_ERROR_MAP.PRODUCT_PRICES_UNAVAILABLE}</p>
          <Button
            className="button-primary"
            onClick={() => window.location.reload()}
          >
            Refresh Page
          </Button>
        </div>
      </div>
    </section>
  )
}

export default ProductPricesUnavailable
